<template>
  <section class="mt-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="here px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">申込者情報確認</h3>
    <p>以下の内容でよろしければ次へ進むを押してください。</p>
    <div class="form-member my-5">
      <div class="inner">
        <form>
          <dl id="dlConfirm">
            <div class="inner">
              <form>
                <dl id="dlConfirm">
                  <dt>氏名</dt>
                  <dd>{{ name1 }}&emsp;{{ name2 }}</dd>
                  <dt>氏名<span class="fs-08">（フリガナ）</span></dt>
                  <dd>{{ nameKana1 }}&emsp;{{ nameKana2 }}</dd>
                  <dt>性別</dt>
                  <dd>{{ sex }}</dd>
                  <dt>配偶者</dt>
                  <dd>{{ spouse }}</dd>
                  <dt>生年月日</dt>
                  <dd>{{ birthDay }}</dd>
                  <dt>郵便番号</dt>
                  <dd>{{ zipCode }}</dd>
                  <dt>住所</dt>
                  <dd>{{ part1OfAddress }}</dd>
                  <dt>住所<span class="fs-08">（フリガナ）</span></dt>
                  <dd>{{ addressKana }}</dd>
                  <dt>住所<span class="fs-08">（建物名）</span></dt>
                  <dd>{{ part2OfAddress }}</dd>
                  <dt>住所<span class="fs-08">（その他）</span></dt>
                  <dd>{{ part3OfAddress }}</dd>
                  <dt>配送時連絡先</dt>
                  <dd>{{ useTelKind }}</dd>
                  <dt>携帯電話番号</dt>
                  <dd>{{ telM }}</dd>
                  <dt>自宅電話番号</dt>
                  <dd>{{ telK }}</dd>
                  <dt>FAX番号</dt>
                  <dd>{{ telF }}</dd>
                  <dt>紹介者の氏名</dt>
                  <dd>{{ spoName1 }}&emsp;{{ spoName2 }}</dd>
                  <dt>紹介者の氏名<span class="fs-08">（フリガナ）</span></dt>
                  <dd>{{ spoNameKana1 }}&emsp;{{ spoNameKana2 }}</dd>
                  <dt>紹介者の会員番号</dt>
                  <dd>{{ spoNumber }}</dd>
                  <dt>紹介者の電話番号</dt>
                  <dd>{{ spoTelNumber }}</dd>
                  <dt>パスワード</dt>
                  <dd>{{ passWord }}</dd>
                  <dt>当社からの広告等のメール・SMS・FAX送信</dt>
                  <dd>{{ wantMail }}</dd>
                  <dt>重要事項への同意</dt>
                  <dd>同意する</dd>
                </dl>
                <div
                  class="
                    box-p-20
                    d-flex
                    justify-content-around
                    text-center
                    column_sp
                  "
                >
                  <div>
                    <router-link
                      :to="{ path: '/shopping/registration' }"
                      class="btn d-inline-block mt-5"
                    >
                      入力画面へ戻る
                    </router-link>
                  </div>
                  <div>
                    <button
                      v-on:click="putData"
                      id="btnSend"
                      type="button"
                      class="confirm-01 clear mt-5"
                    >
                      次へ進む
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </dl>
        </form>
      </div>
    </div>
  </section>
  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ:0120-268-510<br />
      ◆商品相談窓口:0120-649-510
    </p>
  </div>
</template>
<script>
import Request from "@/modules/Request";
let request = new Request();
export default {
  data() {
    return {
      name1: "",
      name2: "",
      nameKana1: "",
      nameKana2: "",
      sex: "",
      spouse: "",
      birthYear: "",
      birthMonth: "",
      birthDay: "",
      zipCode: "",
      part1OfAddress: "",
      part2OfAddress: "",
      part3OfAddress: "",
      addressKana: "",
      useTelKind: "",
      telM: "",
      telK: "",
      telF: "",
      spoName1: "",
      spoName2: "",
      spoNameKana1: "",
      spoNameKana2: "",
      spoNumber: "",
      spoTelNumber: "",
      passWord: "",
      wantMail: "",
    };
  },
  mounted() {
    this.getData();
    window.scroll(0, 0);
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "getRegistration",
        [false],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.name1 = data.name1;
          this.name2 = data.name2;
          this.nameKana1 = data.nameKana1;
          this.nameKana2 = data.nameKana2;
          this.sex = data.sex;
          this.spouse = data.spouse;
          this.birthYear = data.birthYear;
          this.birthMonth = data.birthMonth;
          this.birthDay = data.birthDay;
          this.zipCode = data.zipCode;
          this.part1OfAddress = data.part1OfAddress;
          this.addressKana = data.addressKana;
          this.part2OfAddress = data.part2OfAddress;
          this.part3OfAddress = data.part3OfAddress;
          this.useTelKind = data.useTelKind;
          this.telM = data.telM;
          this.telK = data.telK;
          this.telF = data.telF;
          this.spoName1 = data.spoName1;
          this.spoName2 = data.spoName2;
          this.spoNameKana1 = data.spoNameKana1;
          this.spoNameKana2 = data.spoNameKana2;
          this.spoNumber = data.spoNumber;
          this.spoTelNumber = data.spoTelNumber;
          this.passWord = data.passWord;
          this.wantMail = data.wantMail;
        });
    },
    putData() {
      let requestParams = request.createParams(
        "webMdlNewJoin",
        "setRegistrationForShopping",
        [],
        true
      );
      request
        .create()
        .post("", requestParams)
        .then(() => {
          this.$router.push({
            path: "/shopping/order",
          });
        });
    },
  },
};
</script>
